import { useMutation } from '@tanstack/react-query';
import { CampaignMedium } from '@prisma/client';
import useGetMarketingData from './useGetMarketingData';
import {
  createEmailTemplateAndEmbed,
  createSmsTemplateAndEmbed,
} from '../../services/marketing';
import { CreateTemplateAndEmbedResponse } from '../../types/marketing';
import useGetEmailTemplates from './useGetEmailTemplates';

interface Options {
  onSuccess?: (result: CreateTemplateAndEmbedResponse) => void | Promise<void>;
  onError?: () => void | Promise<void>;
  enabled?: boolean;
}

function useCreateTemplate({
  onSuccess,
  onError,
  enabled = true,
}: Options = {}) {
  const {
    data: marketingData,
    isFetching: isFetchingMarketing,
    isEnabled,
  } = useGetMarketingData();
  const { refetch } = useGetEmailTemplates({
    enabled,
  });

  return useMutation({
    mutationFn: async (medium: CampaignMedium) => {
      if (!marketingData?.id || isFetchingMarketing || !isEnabled) return null;
      const result =
        medium === 'EMAIL'
          ? await createEmailTemplateAndEmbed(marketingData.id)
          : await createSmsTemplateAndEmbed(marketingData.id);
      return result;
    },
    onSuccess: async result => {
      if (!result) return;
      await refetch();
      await onSuccess?.(result);
    },
    onError,
  });
}

export default useCreateTemplate;
